<template>





                   

                       <div  class="singlePage"    :style="singlePage "  >
                       

                        <div class="gutter-row QP"  :style="scrollView"  >
                            <div class="gutter-box" style="position: relative;padding-bottom:0px;    display: flex" >
                                <div style="text-align: center;margin: auto;" class="QP-Header" v-if="show">
                                  
                                        <img src="../../assets/ailogo.png" > 
                                    <div class="sub-sub-title-line">你可以试试这么问我：这篇文章中提到了</div>
                                    <div class="sub-sub-title-line">什么产品，有什么技术参数？</div>
                                 
                                   
                                </div>
                                <div   :class="{'hasChat':!(show)}">
                                    <ChatPage :pageStlye="pageStlye" :postParams="postParams"
                                        @toChangeSelectTrue="toChangeSelectTrue" @toChangeSendText="toChangeSendText"
                                        @toChangeSendTextTrue="toChangeSendTextTrue" @toReloadSession="toReloadSession"
                                        :sendText="sendTextText" :active="{ active: active, articleType: articleType }"
                                        articleType="单篇问答"
                                        :articleId="articleId"
                                        @toShow="toShow"
                                        >
                                    </ChatPage>
                                </div>

                               

                            </div>
                        </div>
                        <div  :class="{'sendTextContainer':true}">
                   
                                    
                                <div style="    width: 100%;
    padding: 0 20px;">
                                    <div :class="{'sendTextArea1':true}">
                                    <a-textarea :bordered="false" v-model:value="sendText" style="background-color: white;"
                                        :autosize="{ minRows: 1, maxRows: maxRows }" placeholder="关于这篇文章，你有什么想要问我的？"
                                        allow-clear @pressEnter="handleKeyPress" @focus="handleFocus" @blur="handleBlur"
                                        class="QiuuArticleTextarea"
                                        >


                                    </a-textarea>

                                    <div class="sendButton" style="margin-left: 5px;"  @click="toSendText"><img style="width: 50%;"
                                            src="../../assets/send.png">
                                    </div>

                              
                                </div>
                                </div>
                                
                            </div>
                       </div>
                       <div style="position: absolute;bottom: 0px;    display: flex;width: 100%;justify-content: center;">
                    <div style="    font-size: 12px;color: #faad14;margin-top: 5px;text-align: center;">
                        AI会犯错，请核查重要信息
                    </div>
                </div>

                   



          
 




</template>
<script>
export default {
    name: 'QiuuPageDetail'
}
</script>
<script setup>
import router from '@/router';

import { nextTick, onMounted, ref, watch, } from 'vue';
import ArticlePage from './component/articlePage.vue';
import ChatPage from './component/chatPage.vue';
import { message } from 'ant-design-vue';
import { articleRecordPage } from './qiuuindex'
import store from '@/store';
import dayjs from 'dayjs';
const articleType = ref("")
const selectTrue = ref(false)
const active = ref(0)
const showProp =defineProps(['scrollViewHeight','articleId'])
const showEmit =defineEmits(['toShow'])
const scrollView =ref("")
const showPage=ref(false)

// watch(() => router.currentRoute.value.query, (val, old) => {

//     if (val && val.name != old.name && router.currentRoute.value.path.indexOf('QiuuPageDetail') > -1) {

//         articleType.value = val.name


//         active.value = router.currentRoute.value.query.conversationId
//         reloaddata()
//     }

// })
const show=ref(true)
const toShow=()=>{
    show.value=false

}
const textAreaFocus=ref(false)
const sendText = ref('')
const sendTextText = ref({ send: false, sendText: '' })
const pageStlye = ref()
const pageContentStlye = ref()
const conversationId = ref()

watch(()=>showProp.scrollViewHeight,(val)=>{
    console.log('val',val)
})
const singlePage=ref('')
const maxRows=ref(4)
onMounted(() => {
 show.value=true


        var parentELement = document.querySelector('.QP')
        console.log(showProp,'props')
        singlePage.value={'padding-top':(document.getElementById('fontArticle').getBoundingClientRect().height+20)+'px'}
        scrollView.value={height:showProp.scrollViewHeight+'px','margin':'10px 0px'}
        console.log(scrollView.value,'scrollView.value')
        console.log(parentELement,'childrenElement',show.value)
        if (parentELement) {

            var childrenElement = document.querySelector('.QP-Header')
            console.log(childrenElement,'childrenElement',show.value)
            if (childrenElement) {
                console.log(parentELement.offsetHeight + "" + childrenElement.offsetHeight + "childrenElement.offsetHeight")
                var pageHeight = parentELement.offsetHeight - childrenElement.offsetHeight - 40 - 42 - 10
                var pageWidth = document.querySelector('.ant-layout-content')

                pageStlye.value = { 'height': pageHeight + 'px', 'overflow-y': 'auto' }
                pageContentStlye.value = { height: '100%', 'flex': 1 }
            
            }
        }
   
    // reloaddata()

})

const changeSendTextTrue = ref(false)
const toChangeSendTextTrue = (val) => {
    changeSendTextTrue.value = val

}
const toReloadSession = (res) => {
    // router.push({
    //     path: '/HomePage/QiuuPageDetail',
    //     query: { name: router.currentRoute.value.query.name, conversationId: res.data.id }
    // })
    // reloaddata()
}
const recordsList=ref([])


const confirmLoading = ref(false)
const toDelete = (item) => {
    deleteItem.value = item
    deleteVisible.value = true

}
const handleKeyPress = async(e) => {
    console.log(e)
    e.preventDefault();
     // 检查是否是Shift+Enter组合键  
     const textarea = e.target
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    if (e.shiftKey) {
        // sendText.value = sendText.value + '\n'
         // 1️⃣ 在光标处插入换行
    const text = sendText.value
    sendText.value =
      text.slice(0, start) + '\n' + text.slice(end)

    // 2️⃣ Vue 更新后，恢复光标到换行后
    await nextTick()
    textarea.setSelectionRange(start + 1, start + 1)
    } else {

        toSendText()
    }


}



const showHistory = ref(false)
const postParams = ref(null)
const toSendParam = (params) => {
    postParams.value = params
    selectTrue.value = true
}
const toSendText = () => {

    if (sendText.value.trim() == '')
        message.warning('发送内容不能为空！')
    else if (changeSendTextTrue.value == true) {
        message.warning('正在请求中，请等待！')
    }
    else {
        changeSendTextTrue.value = true
        sendTextText.value = { send: true, sendText: sendText.value }
    }

}
const toChangeSendText = () => {
    sendText.value = ""
    sendTextText.value = { send: false, sendText: '' }

}

const toChangeSelectTrue = (value) => {
    selectTrue.value = value
    console.log(selectTrue.value, 'selectTrue.value')
}

const sessionList = ref([
])

const handleFocus=()=>{
    textAreaFocus.value=true
    maxRows.value=4
}
const handleBlur=()=>{
    if(!sendText.value){
        textAreaFocus.value=false

    }
 


   

}


</script>
<style lang="less" >
.QiuuArticleTextarea{
    textarea{
        font-size: 16px;
    }
}
</style>
<style lang="less" scoped>

.sendTextArea {

    .ant-input-affix-wrapper {
        border: none !important;
    }
}
.sendTextContainer.areafocus{
    animation: showChat 1s both;
     .sendTextArea1{
        width: 100% !important;
        .ant-input{
        padding: 4px 11px;
        }
        .ant-input-clear-icon{
            display: block;
        }
     }
    .sendButton {
        height: 30px !important;
        width: 30px !important;
     
    }
}
@keyframes showChat {
    0% {
        opacity: 0;
        transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
        opacity: 1;
    }
}
.sendTextArea1 {

.ant-input-affix-wrapper {
    border: none !important;
}
}

.historyButton:hover {
    .svgIcon {
        color: #3db4bb !important;
    }

}

.trash:hover {
    color: red !important;
}

.session:hover {
    .sessionTitle {
        color: #3db4bb
    }
}

</style>
<style scoped>
.singlePage{
    height: 100%; background: #fafafa;;
    position: relative;
}
.hasChat{
    margin-top: 10px;   width: 100%;
}
/* .sendTextArea:focus,
.sendTextArea:active,
.sendTextArea:hover {
    border-color: #79d3d9;
    box-shadow: 0 0 0 2px rgb(0 157 166 / 58%);
} */



.sendTextContainer {
  
    position: absolute;
    /* height: 96px; */
    /*bottom: 72px;*/
    bottom: 10px;
    width: 100%;
  
    display: flex;
    /* align-items: center; */
    justify-content: center;
}
.sendTextArea1::after{
    content: '';
      display: block;
      width: 100%;
      height: 0;
      border-bottom: 2px solid ; /* 设置底部边框 */
      border-image:  linear-gradient(90deg, rgba(114,91,223,1) 0%, rgba(128,163,213,1) 70%, rgba(189,206,234,1) 100%)  0 0 1 0;
      position: absolute;
      bottom: 0;
      left: 0;
}

.sendTextArea1 {
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid rgba(5, 5, 5, 0.06);


    /* border-right-width: 1px !important; */
    /* outline: 0; */
    padding: 6px 2px;
    position: relative;
    z-index: 1000;
    bottom: 10px;
    background-color: white;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    
}

.sendTextArea {
    width: 95%;
    display: flex;
    align-items: center;
    border: 1px transparent;
    border-color: #e5e5e5;
    /* border-right-width: 1px !important; */
    /* outline: 0; */
    padding: 2px 2px;
    position: absolute;
    z-index: 1000;
    bottom: 1px;
    background-color: white;
 
    
}
.sendTextArea1 {
    .ant-input{
        padding: 4px 4px;
    }
    .ant-input-clear-icon{
        display: none;
    }

}
/* 
.gradient-border {
      position: relative;
      padding: 10px;
      border: 2px solid transparent;
      border-radius: 5px;
      background-clip: padding-box;
    } */

    .sendTextArea::before {
      content: '';
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      border-radius: 5px;
      background: linear-gradient(90deg, rgba(114,91,223,1) 0%, rgba(128,163,213,1) 70%, rgba(189,206,234,1) 100%);
      z-index: -1;
      transition: transform 0.5s ease;
      background-size: 200% 200%;
      animation: gradient-flow 5s linear infinite;
    }

    .gradient-border:focus::before {
      transform: rotate(360deg);
    }

    .gradient-border:focus {
      outline: none;
    }

    @keyframes gradient-flow {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }



.sendButton {
    cursor: pointer;
    background-color: #735fdf;
    width: 25px;
    height: 25px;
    text-align: center;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.divFlex {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
}

.session {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 15px;
    cursor: pointer;
}

.session:hover,
.session-active {
    position: relative;
    box-shadow: 0 0 6px 0 rgba(113, 127, 167, .28);
    background-color: #f8f8f8;
}


.session:hover:before,
.session-active:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 2px;
    background-color: #79d3d9;
    top: 0;
    left: 0;

}

.sessionTitle {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.newChatButton {
    margin: 15px 0px;
    cursor: pointer;
    width: 168px;
    height: 40px;
    background: #009da6;
    border-radius: 8px;
    color: white;
    line-height: 40px;
    text-align: center;
}

.historyButton {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}




.gutter-box {
    background:  #f6f7fb;
;

    height: 100%;
}

.no-padding {
    padding-bottom: 0px !important;
}

.QP {
    /* margin-right: 5px */
}

.historyText {
    color: #1a2029;
    font-family: "PingFang SC";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}
</style>